import {formatHuman} from "../../utils/utils";

const validateChars = (value) => {
    const res = !!/^[a-z]+$/.test(value)
    return {
        valid: res,
        error: 'Csak ékezet nélküli kisbetűs karaktereket tartalmazhat (a-z)'
    }
}

const validateMinLength = (minLength, value) => {
    const res = value.length > minLength
    return {
        valid: res,
        error: `Legalább ${minLength + 1} karakter hosszú kell hogy legyen`
    }
}

const validateMaxLength = (maxLength, value) => {
    const res = value.length < maxLength
    return {
        valid: res,
        error: `Legfeljebb ${maxLength} karakter hosszú lehet`
    }
}

const validateEmail = (value) => {
    if (!value) return {
        valid: true,
        error: 'Nem kötelezö mező'
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const res = emailRegex.test(value);
    return {
        valid: res,
        error: 'Nem érvényes e-mail cím'
    }
}

const validateVatNumber = (value) => {
    if (!value) return {
        valid: true,
        error: 'Nem kötelezö mező'
    }
    const emailRegex = /^\d{8}-\d-\d{2}$/;
    const res = emailRegex.test(value);
    return {
        valid: res,
        error: 'Nem érvényes adószám, (xxxxxxxx-y-zz)'
    }
}

const validateNumber = (value) => {
    if (!value) return {
        valid: true,
        error: 'Nem kötelezö mező'
    }
    const numericRegex = /^-?[0-9]+$/;
    const res = numericRegex.test(value);
    return {
        valid: value ? res : true,
        error: 'Csak számokat tartalmazhat'
    }
}

const validateAnyNumber = (value) => {
    if (!value) return {
        valid: true,
        error: 'Nem kötelezö mező'
    }
    // Accepts integers and decimals (with optional minus sign)
    const numericRegex = /^-?\d+(\.\d+)?$/;
    const res = numericRegex.test(value);
    return {
        valid: res,
        error: res ? null : 'Csak számokat tartalmazhat (tizedes is megengedett)'
    }
}


const validateNonNegativeNumber = (value) => {
    if (!value) return {
        valid: true,
        error: 'Nem kötelezö mező'
    }
    const numericRegex = /^-?[0-9]+$/;
    const res = numericRegex.test(value);
    return {
        valid: value ? res && parseInt(value) >= 0 : true,
        error: 'Nem lehet negatív szám'
    }
}

const validateMin = (value, minNumber) => {
    if (!value) return {
        valid: true,
        error: 'Nem kötelezö mező'
    }
    return {
        valid: value >= minNumber,
        error: `Nem lehet kisebb mint ${minNumber}`
    }
}

const validateMax = (value, maxNumber) => {
    if (!value) return {
        valid: true,
        error: 'Nem kötelezö mező'
    }
    return {
        valid: value <= maxNumber,
        error: `Nem lehet nagyobb mint ${maxNumber}`
    }
}

const validateRequired = (value) => {
    return {
        valid: Boolean(value),
        error: 'Nem maradhat üresen'
    }
}

const validateRequiredIf = (value, condition) => {
    if (!condition) {
        return {
            valid: true,
            error: ''
        }
    }
    return {
        valid: Boolean(value),
        error: 'Nem maradhat üresen'
    }
}

const validateEqualsPassword = (equal, value) => {
    return {
        valid: equal === value,
        error: 'Nem egyezik meg a két jelszó'
    }
}

const validateDate = (value) => {
    const isValidDate = (date) => {
        if (typeof date === 'string') {
            const parsedDate = new Date(date);
            // Check if the parsed date is valid and if the original string was a valid date format
            return !isNaN(parsedDate) && parsedDate.toISOString().startsWith(date);

        } else if (date instanceof Date) {
            return !isNaN(date);
        }
        return false;
    };
    return {
        valid: isValidDate(value),
        error: 'Helytelen dátum'
    }
}


const validatePassword = (value) => {
    const hasNumber = /\d/;
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;

    const isValid = hasNumber.test(value) && hasSpecialChar.test(value)
    return {
        valid: isValid,
        error: 'Tartalmaznia kell egy speciális karaktert (!@#$%^&*(),.?":{}|<>) és egy számot'
    }
}

const validateTime = (value) => {
    console.log(value)
    if (!value) return {
        valid: true,
        error: null
    }
    const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$/;
    const res = timeRegex.test(value);
    return {
        valid: res,
        error: 'Nem érvényes idő formátum (HH:mm)'
    }
}

const validateMaxDateDiff = (maxDays, value, compareDate) => {
    if (!value || !compareDate) return {
        valid: true,
        error: 'Nem kötelezö mező'
    }

    const date1 = new Date(value);
    const date2 = new Date(compareDate);
    
    // Check if dates are valid
    if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
        return {
            valid: false,
            error: 'Helytelen dátum formátum'
        }
    }

    // Calculate difference in days
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return {
        valid: diffDays <= maxDays,
        error: `A két dátum között nem lehet több mint ${maxDays} nap különbség`
    }
}

export {
    validateChars,
    validateMinLength,
    validateEmail,
    validateRequired,
    validateEqualsPassword,
    validatePassword,
    validateMaxLength,
    validateNumber,
    validateVatNumber,
    validateDate,
    validateNonNegativeNumber,
    validateTime,
    validateMaxDateDiff,
    validateMin,
    validateMax,
    validateRequiredIf,
    validateAnyNumber
}